export const usersEndPoints = {
  register: () => '/users/register',
  //
  login: () => '/users/login',
  refresh: () => '/session/refresh',
  googleAuth: () => '/users/googleAuth',
  //
  logout: () => '/users/logout',
  getMe: () => '/users/me',

  //
  verifyEmail: () => `/users/verify`,
  requestResetPassword: () => `/users/requestResetPassword`,
  resetPassword: () => `/users/resetPassword`,
};
